import { render } from "./SectionLayout.vue?vue&type=template&id=0c8d88fa"
import script from "./SectionLayout.vue?vue&type=script&lang=js"
export * from "./SectionLayout.vue?vue&type=script&lang=js"

import "./SectionLayout.vue?vue&type=style&index=0&id=0c8d88fa&lang=scss"

import exportComponent from "/opt/build/repo/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__